import { Donation } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Donation>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminDonationsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminDonation.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminDonation.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminDonation.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminDonation.reset.type]: actionsHandlers.handleGetOneReset,
  [actions.runtimeUpdateAdminDonation.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.runtimeUpdateAdminDonation.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.runtimeUpdateAdminDonation.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.runtimeUpdateAdminDonation.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default adminDonationsReducer;
